export const calculateRemainingSeconds = (timer) => {
  if (!timer) {
    return null;
  }
  if (!timer.endsAt) {
    return null;
  }
  const endsAt = timer.endsAt instanceof Date ? timer.endsAt : new Date(timer.endsAt);
  if (Number.isNaN(endsAt?.getTime?.() ?? NaN)) {
    return null;
  }
  const now = Date.now();
  const remaining = Math.floor((endsAt.getTime() - now) / 1000);
  return Number.isFinite(remaining) ? Math.max(0, remaining) : null;
};

export const formatDuration = (seconds) => {
  if (!Number.isFinite(seconds) || seconds < 0) {
    return '--:--';
  }
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

export const parseBackendTimer = (timer) => {
  if (!timer) {
    return null;
  }
  const startedAt = timer.startedAt || timer.started_at;
  const endsAt = timer.endsAt || timer.ends_at;
  const durationSeconds = timer.durationSeconds ?? timer.duration_seconds;
  return {
    startedAt: startedAt ? new Date(startedAt) : null,
    endsAt: endsAt ? new Date(endsAt) : null,
    durationSeconds,
  };
};
